export default {"src":"/_next/static/media/info-icon.ccd077e6.svg","height":20,"width":20};